var render = function render(_c, _vm) {
  return _c(
    "wa-question-and-answer",
    { attrs: { id: "limited-damages", title: "Limited Damages" } },
    [
      _vm._v("\n  If the\n  "),
      _c("em", [_vm._v("Customer")]),
      _vm._v("\n  takes legal action against the\n  "),
      _c("em", [_vm._v("Company")]),
      _vm._v(
        "\n  related to Font Awesome Pro, under contract law, tort law, or any other kind of law, the\n  "
      ),
      _c("em", [_vm._v("Customer")]),
      _vm._v("\n  's damages will be capped at the amount of fees the\n  "),
      _c("em", [_vm._v("Customer")]),
      _vm._v("\n  actually paid the\n  "),
      _c("em", [_vm._v("Company")]),
      _vm._v(
        "\n  under this agreement. Under no circumstance shall the Customer be entitled to punitive, exemplary, consequential, or indirect damages. If the Company takes\n  legal action against the Customer related to Font Awesome Pro, under contract law, tort law, or any other kind of law, Font Awesome Pro shall not be\n  entitled to receive punitive, exemplary, consequential, or indirect damages.\n"
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }